/**
 * Menu Manage — Sorting utilities for multi-level drag-and-drop reordering.
 */

import type { MenuCategory, MenuItem, OptionGroup, MenuItemOption } from './types';

/** Move an element within an array from index `from` to index `to`. */
function arrayMove<T>(arr: T[], from: number, to: number): T[] {
  if (from === to) return arr;
  const next = [...arr];
  const [item] = next.splice(from, 1);
  next.splice(to, 0, item);
  return next;
}

/** Reorder categories within a profile and update sortOrder. */
export function reorderCategories(
  categories: MenuCategory[],
  fromIndex: number,
  toIndex: number,
): MenuCategory[] {
  return arrayMove(categories, fromIndex, toIndex).map((c, i) => ({
    ...c,
    sortOrder: i,
  }));
}

/** Reorder items within a single category and update sortOrder. */
export function reorderItems(
  items: MenuItem[],
  fromIndex: number,
  toIndex: number,
): MenuItem[] {
  return arrayMove(items, fromIndex, toIndex).map((it, i) => ({
    ...it,
    sortOrder: i,
  }));
}

/** Reorder option groups within a single item. */
export function reorderGroups(
  groups: OptionGroup[],
  fromIndex: number,
  toIndex: number,
): OptionGroup[] {
  return arrayMove(groups, fromIndex, toIndex);
}

/** Reorder options within a single option group. */
export function reorderOptions(
  options: MenuItemOption[],
  fromIndex: number,
  toIndex: number,
): MenuItemOption[] {
  return arrayMove(options, fromIndex, toIndex);
}
